module.exports = __webpack_public_path__ + "img/earth.f6efb2c9.svg";